export function useLanguageOptions() {
  function getLanguageOptions(users: Array<any>): Array<string> {
    const languages = users.reduce((languages: string[], user: any) => {
      const userLanguages = user.languages_list || [];

      userLanguages.forEach((language: string) => {
        if (!languages.includes(language)) {
          languages.push(language);
        }
      });

      return languages;
    }, [] as string[]);

    const prioritizedLanguages = ['Svenska', 'Engelska', 'Dansk', 'Engelsk'];

    return prioritizedLanguages
      .filter((lang) => languages.includes(lang))
      .concat(
        ...languages
          .filter((lang: string) => !prioritizedLanguages.includes(lang))
          .sort((a: string, b: string) => a.localeCompare(b))
      );
  }

  return {
    getLanguageOptions,
  };
}
